import { render, staticRenderFns } from "./sysuser_edit.vue?vue&type=template&id=2d804b9b&scoped=true"
import script from "./sysuser_edit.vue?vue&type=script&lang=js"
export * from "./sysuser_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d804b9b",
  null
  
)

export default component.exports